<template>
    <div class="mt-3">
        
        <div class="loading" v-if="loading"><b-spinner label="Loading..."></b-spinner></div>
        
        <div class="mb-3">
            <h5><div class="form-subheader"><span>Quiver</span></div></h5>
        </div>
        
        <div v-if="alertMessage">
            <b-alert show :variant="alertVariant">{{ alertMessage }}</b-alert>
        </div>

        <div class="row">
          
            <!-- Empresa -->
            <div class="col-12 col-lg-4 mb-3 pr-md-4">
                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_holding">Holding</label>
                        <select v-if="editable" class="form-control" id="slt_holding"
                            v-model="dataFormPolicyConfiguration.holding_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listHoldings" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormPolicyConfiguration?.holding?.name || '-' }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_regional">Regional</label>
                        <select v-if="editable" class="form-control" id="slt_regional"
                            v-model="dataFormPolicyConfiguration.regional_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listRegions" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormPolicyConfiguration?.regional?.name || '-' }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_broker">Corretora</label>
                        <select v-if="editable" class="form-control" id="slt_broker"
                            v-model="dataFormPolicyConfiguration.broker_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listBrokers" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormPolicyConfiguration?.broker?.name || '-' }}</p>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_broker">Co-corretagem</label>
                        <select v-if="editable" class="form-control" id="slt_broker"
                            v-model="dataFormPolicyConfiguration.cobroker_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listCoBrokers" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormPolicyConfiguration?.cobroker?.name || '-' }}</p>
                    </div>
                </div>
            </div>
            
            <!-- Negócio -->
            <div class="col-12 col-lg-4 pl-md-4 border-left">
                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_channel">Canal</label>
                        <select v-if="editable" class="form-control" id="slt_channel"
                            v-model="dataFormPolicyConfiguration.channel_id" @change="storeQuiverConfiguration" >
                            <option :value="null"></option>
                            <option v-for="item in listChanels" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormPolicyConfiguration?.channel?.name || '-' }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_point_sale">Ponto de venda</label>
                        <select v-if="editable" class="form-control" id="slt_point_sale"
                            v-model="dataFormPolicyConfiguration.point_sale_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listPointOfSales" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormPolicyConfiguration?.point_sale?.name || '-' }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_business_line">Linhas de negócio</label>
                        <select v-if="editable" class="form-control" id="slt_business_line"
                            v-model="dataFormPolicyConfiguration.business_line_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listBusinessLines" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormPolicyConfiguration?.business_line?.name || '-' }}</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="slt_business_origin">Origem do negócio</label>
                        <select v-if="editable" class="form-control" id="slt_business_origin"
                            v-model="dataFormPolicyConfiguration.business_origin_id" @change="storeQuiverConfiguration">
                            <option :value="null"></option>
                            <option v-for="item in listBusinessOrigins" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>{{ dataFormPolicyConfiguration?.business_origin?.name || '-' }}</p>
                    </div>
                </div>                
            </div>
            
            <!-- Usuários -->
            <div class="col-12 col-lg-4 pl-md-4 border-left">
                <div class="row">
                    <div class="col-md-12 mb-3">
                        <label class="dbo-ui">
                            Comercial Responsável
                            <i class="fas fa-info-circle ml-2" v-b-tooltip.hover title="Produtor"></i>
                        </label>
                        <select v-if="editable" class="form-control" 
                            v-model="dataFormPolicyConfiguration.commercial_id" @change="storeQuiverConfiguration">

                            <option :value="null"></option>
                            <option v-for="item in filteredOptionsCommercial" :key="item.value" :value="item.value">
                                {{ item.text }}
                            </option>
                        </select>
                        <p v-else>
                            {{ dataFormPolicyConfiguration.commercial_id ?
                                dataFormPolicyConfiguration?.commercial?.name + ' (' + dataFormPolicyConfiguration?.commercial?.email + ')' :
                                '-'
                            }}
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="group_name">Técnico</label>
                        <select v-if="editable" class="form-control" 
                            v-model="dataFormPolicyConfiguration.technical_user_id" @change="storeQuiverConfiguration">

                            <option :value="null"></option>
                            <option v-for="item in filteredOptionsCommercial" :key="item.value" :value="item.value">
                                {{ item.text }}
                            </option>
                        </select>
                        <p v-else>
                            {{ dataFormPolicyConfiguration.technical_user_id ?
                                dataFormPolicyConfiguration?.technical_user?.name + ' (' + dataFormPolicyConfiguration?.technical_user?.email + ')' :
                                '-'
                            }}
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-md-12 mb-3">
                        <label class="dbo-ui" for="group_name">Indicador</label>
                        <select v-if="editable" class="form-control" 
                            v-model="dataFormPolicyConfiguration.indicator_user_id" @change="storeQuiverConfiguration">

                            <option :value="null"></option>
                            <option v-for="item in listIndicatorUsers" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                        <p v-else>
                            {{ dataFormPolicyConfiguration.indicator_user_id ?
                                dataFormPolicyConfiguration?.indicator_user?.name + ' (' + dataFormPolicyConfiguration?.indicator_user?.email + ')' :
                                '-'
                            }}
                        </p>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import dateFormatterMixin from "@/mixins/dateFormatter";
import commomsHelperMixin from "@/mixins/commomsHelper";
import companyService from "@/services/company";
import policyService from "@/services/policy";
import quiverService from "@/services/quiver";
import brokerService from "@/services/broker";

export default {
  props: {
    policyID: String,
    dataForm: Object,
    editable: { type: Boolean, default: false }
  },
  emits: ["updateDataformQuiverConfiguration"],
  mixins: [dateFormatterMixin, commomsHelperMixin],
  data: () => ({
    loading: false,

    searchQueryCommercial: "",
    selectedCommercialData: null,
    commercialOptions: [],

    listHoldings: [],
    listPointOfSales: [],
    listRegions: [],
    listBrokers: [],
    listChanels: [],
    listBusinessLines: [],
    listBusinessOrigins: [],
    listCoBrokers: [],
    listIndicatorUsers: [],

    dataFormPolicyConfiguration: {
        holding_id: null,
        regional_id: null,
        broker_id: null,
        channel_id: null,
        point_sale_id: null,
        business_line_id: null, 
        business_origin_id: null,
        commercial_id: null,
        indicator_user_id: null,
        technical_user_id: null,
        cobroker_id: null
    }
  }),
  created() {
    this.resetAlert();
    this.getData();
  },
  methods: {
    getData() {
        this.loading = true;

        let requests = [];

        if (this.policyID) {
            requests.push(this.getPolicyQuiverConfigurations());
        }

        if (this.editable) {
            requests.push(this.getResponsibleCommercial());
            requests.push(this.getQuiverHoldingOptions());
            requests.push(this.getQuiverPointSaleOptions());
            requests.push(this.getQuiverBusinessLineOptions());
            requests.push(this.getQuiverBusinessOriginOptions());
            requests.push(this.getQuiverChannelOptions());
            requests.push(this.getQuiverRegionalOptions());
            requests.push(this.getQuiverRegionalOptions());
            requests.push(this.getBrokers());
            requests.push(this.getIndicatorUsers());
            requests.push(this.getCoBrokers());
        }

        Promise.all(requests)
            .finally(() => {
                this.loading = false;
            });
    },
    getPolicyQuiverConfigurations() {
        return policyService
            .getPolicyQuiverConfigurations(this.policyID)
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                if (response.data?.id) {
                    this.dataFormPolicyConfiguration = response.data;
                }
            })
            .catch((error) => {
                this.showError(error);
            });
    },
    getResponsibleCommercial() {
        return companyService
            .getResponsibleCommercial()
            .then((response) => {
                if (response.data.error) {
                    return;
                }
                this.commercialOptions = response.data;
            })
            .catch(() => {
                this.showError("Não foi possível receber lista de comerciais responsáveis do grupo econômico.");
            });
    },
    storeQuiverConfiguration() {
        this.$emit('updateDataformQuiverConfiguration', this.dataFormPolicyConfiguration);
    },
    getQuiverHoldingOptions() {
        return quiverService
            .getQuiverHoldingOptions()
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.listHoldings = response.data;
            })
            .catch(() => {
                this.showError('Não foi possível carregar as opções de holdings.');
            });
    },
    getQuiverPointSaleOptions() {
        return quiverService
            .getQuiverPointSaleOptions()
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.listPointOfSales = response.data;
            })
            .catch(() => {
                this.showError('Não foi possível carregar as opções de pontos de venda.');
            });
    },
    getQuiverBusinessLineOptions() {
        return quiverService
            .getQuiverBusinessLineOptions()
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.listBusinessLines = response.data;
            })
            .catch(() => {
                this.showError('Não foi possível carregar as opções de linhas de negócio.');
            });
    },
    getQuiverBusinessOriginOptions() {
        return quiverService
            .getQuiverBusinessOriginOptions()
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.listBusinessOrigins = response.data;
            })
            .catch(() => {
                this.showError('Não foi possível carregar as opções de origens de negócio.');
            });
    },
    getQuiverChannelOptions() {
        return quiverService
            .getQuiverChannelOptions()
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.listChanels = response.data;
            })
            .catch(() => {
                this.showError('Não foi possível carregar as opções de canais.');
            });
    },
    getQuiverRegionalOptions() {
        return quiverService
            .getQuiverRegionalOptions()
            .then((response) => {
                if (response.data.error) {
                    this.showError(response.data.message);
                    return;
                }
                this.listRegions = response.data;
            })
            .catch(() => {
                this.showError('Não foi possível carregar as opções de regiões.');
            });
    },
    getBrokers() {
      return brokerService
        .get()
        .then((response) => {
            if (response.data.error) {
                console.error(response);
                return;
            }
            this.listBrokers = response.data;
        })
        .catch(() => {
          console.error("Não foi possível recuperar os corretores.");
        });
    },
    getCoBrokers() {
      return quiverService
        .getQuiverCoBrokersOptions()
        .then((response) => {
            if (response.data.error) {
                return;
            }
            this.listCoBrokers = response.data;
        })
        .catch(() => {
          console.error("Não foi possível recuperar os corretores.");
        });
    },
    getIndicatorUsers() {
      return quiverService
        .getQuiverIndicatorUsersOptions()
        .then((response) => {
            if (response.data.error) {
                console.error(response);
                return;
            }
            this.listIndicatorUsers = response.data;
        })
        .catch(() => {
          console.error("Não foi possível recuperar os usuários indicadores.");
        });
    },
  },
  computed: {
      selectedCommercial() {
          return (this.selectedCommercialData || { text: "Informe o usuário" });
      },
      filteredOptionsCommercial() {
          return [
            // { text: 'Nenhuma opção.', value: '' },
            ...this.commercialOptions.filter((option) =>
                option.text.toLowerCase().includes(this.searchQueryCommercial.toLowerCase())
            )
          ];
      },
  },
  watch: {
    dataForm: function (value) {
        this.dataFormPolicyConfiguration = value;
    },
  },
};
</script>
<style scoped>
.loading { position: absolute; top: 0px; left: 0px; display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; background-color: rgba(255, 255, 255, 0.7); z-index: 999; }
</style>

